<template>

    <v-card>
      <v-card-title>
        <span class="primary--text">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field v-model="item.firstName" label="First Name"></v-text-field>
              <v-text-field v-model="item.lastName" label="Last Name"></v-text-field>
               <v-text-field v-model="item.companyName" label="Company"></v-text-field>
               <validation-provider
                  v-slot="{ errors }"
                  rules="vatLength"
                >
                <v-text-field 
                  v-model="item.vatNo" 
                  label="VAT" 
                  :class="(errors[0]) ? 'error--text' : ''"
                ></v-text-field>
                <span class="error--text">{{ errors[0] }}</span>
                </validation-provider>
                <v-text-field v-model="item.emailAddress" label="Email"></v-text-field>
                <v-text-field v-model="item.mobile" label="Mobile"></v-text-field>
                <v-select v-model="item.scope"
                        :items="userScopes"
                        label="User Role"
              >
                {{ item.scope }}
              </v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

</template>

<script>
import { ValidationProvider, extend} from 'vee-validate';

extend('vatLength', {
  params: [],
  validate(value) {
    if(value.length == 10)
    return /^[0-9]+$/.test(value);
  },
  message: 'Vat number must be 10 digits only'
})
export default {
  name: "CreateDialog",
  props: {
    formTitle: String,
    item: Object,
    closeFunction: Function,
    saveFunction: Function
  },
  components: {
    ValidationProvider
  },
  data() {
    return {
      userScopes: [
        'client',
        'driver',
        'admin'
      ]
    }
  },
  methods: {
    close() {
      this.closeFunction();
    },
    save() {
      this.saveFunction();
    }
  },
  mounted() {}
}
</script>

<style scoped>

</style>